export default [
  {
    path: '/cash/:key?',
    name: 'cashPage',
    component: () => import(/*webpackChunkName:'cash'*/ '@/views/cash/index.vue'),
    meta: {},
  },
];
